import React, { useEffect, useState } from 'react'
import * as bie from "react-bootstrap";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { AC_YEAR } from '../../CommonUtils/contextVariables';
import { InfoAlert } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaFilePdf } from 'react-icons/fa';

export default function AfflGovtOverallStatus2223Report() {
    const [showName, setShowName] = useState("");
    const acYear = sessionStorage.getItem('ac_year');

    const [showDrillCount, setShowDrillCount] = useState();
    const [universityWiseCourseData, setUniversityWiseCourseData] = useState([]);

    function GettUniversityWiseCourseDetails(ubcode, level) {
        let url = config.url.API_URL + "getcollegesreport/" + ubcode + "/" + level;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUniversityWiseCourseData(res?.data?.data);
                setShowDrillCount(1)
            }
            else {
                setUniversityWiseCourseData([])
                // InfoAlert("No Data found")
            }
        })
    }




    const OverallOamdcStatusColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "University Name", accessor: "ub_name", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        ///


        {
            Header: "Govt Colleges", // Parent header
            columns: [                 // Children go here
                {
                    Header: "Govt Colleges", accessor: "gdc_count",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.gdc_count === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 1);
                                    setShowName("Govt Colleges")
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 1);
                                    setShowName("Govt Colleges")
                                }
                            }}  >{row?.values?.gdc_count}</div>
                    ),
                    Footer: "gdc_count"
                },


                {
                    Header: `Govt Affiliation Applied ${AC_YEAR}`, accessor: "reg_gdc_count_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_gdc_count_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 4);
                                    setShowName(`Govt Affiliation Applied ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 4);
                                    setShowName(`Govt Affiliation Applied ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_gdc_count_24}</div>
                    ),
                    Footer: "reg_gdc_count_24"
                },
                {
                    Header: `Govt Affiliation Not Applied ${AC_YEAR}`, accessor: "reg_not_gdc_count_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_not_gdc_count_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 5);
                                    setShowName(`Govt Affiliation Not Applied ${AC_YEAR}`)
                                }
                            }
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 5);
                                    setShowName(`Govt Affiliation Not Applied ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_not_gdc_count_24}</div>
                    ),
                    Footer: "reg_not_gdc_count_24"
                },



                {
                    Header: `Govt Colleges CDC Done ${AC_YEAR}`, accessor: "reg_gdc_count_cdc_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_gdc_count_cdc_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 10);
                                    setShowName(`Govt Colleges CDC Done ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 10);
                                    setShowName(`Govt Colleges CDC Done ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_gdc_count_cdc_24}</div>
                    ),
                    Footer: "reg_gdc_count_cdc_24"
                },

                {
                    Header: `Govt Colleges CDC Not Done ${AC_YEAR}`, accessor: "reg_gdc_not_count_cdc_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_gdc_not_count_cdc_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 11);
                                    setShowName(`Govt Colleges CDC Not Done ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 11);
                                    setShowName(`Govt Colleges CDC Not Done ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_gdc_not_count_cdc_24}</div>
                    ),
                    Footer: "reg_gdc_not_count_cdc_24"
                },

                {
                    Header: `Govt Colleges AO Done ${AC_YEAR}`, accessor: "reg_gdc_count_ao_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_gdc_count_ao_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 16);
                                    setShowName(`Govt Colleges AO Done ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 16);
                                    setShowName(`Govt Colleges AO Done ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_gdc_count_ao_24}</div>
                    ),
                    Footer: "reg_gdc_count_ao_24"
                }, {
                    Header: `Govt Colleges AO Not Done ${AC_YEAR}`, accessor: "reg_gdc_not_count_ao_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_gdc_not_count_ao_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 17);
                                    setShowName(`Govt Colleges AO Not Done ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 17);
                                    setShowName(`Govt Colleges AO Not Done ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_gdc_not_count_ao_24}</div>
                    ),
                    Footer: "reg_gdc_not_count_ao_24"
                },
            ],
        },




        // ...

        {
            Header: "Private Aided Colleges", // Parent header
            columns: [
                {
                    Header: "Private Aided Colleges", accessor: "pac_count",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.pac_count === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 2);
                                    setShowName("Private Aided Colleges")
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 2);
                                    setShowName("Private Aided Colleges")
                                }
                            }}  >{row?.values?.pac_count}</div>
                    ),
                    Footer: "pac_count"
                },

                {
                    Header: `Private Aided Affiliation Applied ${AC_YEAR}`, accessor: "reg_pac_count_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_pac_count_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 6);
                                    setShowName(`Private Aided Affiliation Applied ${AC_YEAR}`)
                                }
                            }
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 6);
                                    setShowName(`Private Aided Affiliation Applied ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_pac_count_24}</div>
                    ),
                    Footer: "reg_pac_count_24"
                },
                {
                    Header: `Private Aided Affiliation Not Applied ${AC_YEAR}`, accessor: "reg_not_pac_count_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_not_pac_count_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 7);
                                    setShowName(`Private Aided Affiliation Not Applied ${AC_YEAR}`)
                                }
                            }
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 7);
                                    setShowName(`Private Aided Affiliation Not Applied ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_not_pac_count_24}</div>
                    ),
                    Footer: "reg_not_pac_count_24"
                },

                {
                    Header: `Private Aided Colleges CDC Done ${AC_YEAR} `, accessor: "reg_pac_count_cdc_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_pac_count_cdc_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 12);
                                    setShowName(`Private Aided Colleges CDC Done ${AC_YEAR}`)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 12);
                                    setShowName(`Private Aided Colleges CDC Done ${AC_YEAR}`)
                                }
                            }}  >{row?.values?.reg_pac_count_cdc_24}</div>
                    ),
                    Footer: "reg_pac_count_cdc_24"
                },
                {
                    Header: `Private Aided Colleges CDC Not Done ${AC_YEAR} `, accessor: "reg_pac_not_count_cdc_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_pac_not_count_cdc_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 13);
                                    setShowName(`Private Aided Colleges CDC Not Done ${AC_YEAR} `)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 13);
                                    setShowName(`Private Aided Colleges CDC Not Done ${AC_YEAR} `)
                                }
                            }}  >{row?.values?.reg_pac_not_count_cdc_24}</div>
                    ),
                    Footer: "reg_pac_not_count_cdc_24"
                },


                {
                    Header: `Private Aided Colleges AO Done ${AC_YEAR}`, accessor: "reg_pac_count_ao_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_pac_count_ao_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {

                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 18);
                                    setShowName(`Private Aided Colleges AO Done ${AC_YEAR} `)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 18);
                                    setShowName(`Private Aided Colleges AO Done ${AC_YEAR} `)
                                }
                            }}  >{row?.values?.reg_pac_count_ao_24}</div>
                    ),
                    Footer: "reg_pac_count_ao_24"
                },

                {
                    Header: `Private Aided Colleges AO Not Done ${AC_YEAR} `, accessor: "reg_pac_not_count_ao_24",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                if (row?.original?.reg_pac_not_count_ao_24 === 0) {
                                    InfoAlert("No Data Found")
                                }
                                else {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 19);
                                    setShowName(`Private Aided Colleges AO Not Done ${AC_YEAR} `)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 19);
                                    setShowName(`Private Aided Colleges AO Not Done ${AC_YEAR} `)
                                }
                            }}  >{row?.values?.reg_pac_not_count_ao_24}</div>
                    ),
                    Footer: "reg_pac_not_count_ao_24"
                },


            ]
        },



        // {
        //     Header: "Total Colleges", // Parent header
        //     columns: [
        //         {
        //             Header: "Total GOVT/PAC Colleges", accessor: "total",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total === 0) {
        //                             InfoAlert("No Data Found")
        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 3);
        //                             setShowName("Total GOVT/PAC Colleges")
        //                         }
        //                     }}
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 3);
        //                             setShowName("Total GOVT/PAC Colleges")
        //                         }
        //                     }}  >{row?.values?.total}</div>
        //             ),
        //             Footer: "total"
        //         },



        //         {
        //             Header: `Total Colleges Applied ${AC_YEAR}`, accessor: "total_coll_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_coll_app_24 === 0) {
        //                             InfoAlert("No Data Found")
        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 8);
        //                             setShowName(`Total Colleges Applied ${AC_YEAR}`)
        //                         }
        //                     }
        //                     }
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 8);
        //                             setShowName(`Total Colleges Applied ${AC_YEAR}`)
        //                         }
        //                     }} > {row?.values?.total_coll_app_24}</div >
        //             ),
        //             Footer: "total_coll_app_24"
        //         },

        //         {
        //             Header: `Total Colleges Not Applied ${AC_YEAR}`, accessor: "total_not_coll_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_not_coll_app_24 === 0) {
        //                             InfoAlert("No Data Found")
        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 9);
        //                             setShowName(`Total Colleges Not Applied ${AC_YEAR}`)
        //                         }
        //                     }
        //                     }
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 9);
        //                             setShowName(`Total Colleges Not Applied ${AC_YEAR}`)
        //                         }
        //                     }}  >{row?.values?.total_not_coll_app_24}</div>
        //             ),
        //             Footer: "total_not_coll_app_24"
        //         },







        //         {
        //             Header: `Total Colleges CDC Done`, accessor: "total_cdc_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_cdc_app_24 === 0) {
        //                             InfoAlert("No Data Found")
        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 14);
        //                             setShowName("Total Colleges CDC Done")
        //                         }
        //                     }}
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 14);
        //                             setShowName("Total Colleges CDC Done")
        //                         }
        //                     }}  >{row?.values?.total_cdc_app_24}</div>
        //             ),
        //             Footer: "total_cdc_app_24"
        //         },
        //         {
        //             Header: `Total Colleges CDC Not Done`, accessor: "total_not_cdc_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_not_cdc_app_24 === 0) {
        //                             InfoAlert("No Data Found")
        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 15);
        //                             setShowName("Total Colleges CDC Not Done")
        //                         }
        //                     }}
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 15);
        //                             setShowName("Total Colleges CDC Not Done")
        //                         }
        //                     }}  >{row?.values?.total_not_cdc_app_24}</div>
        //             ),
        //             Footer: "total_not_cdc_app_24"
        //         },



        //         {
        //             Header: `Total Colleges AO Done`, accessor: "total_ao_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_ao_app_24 === 0) {
        //                             InfoAlert("No Data Found")

        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 20);
        //                             setShowName("Total Colleges AO Done")
        //                         }
        //                     }}
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 20);
        //                             setShowName("Total Colleges AO Done")
        //                         }
        //                     }}  >{row?.values?.total_ao_app_24}</div>
        //             ),
        //             Footer: "total_ao_app_24"
        //         },

        //         {
        //             Header: `Total Colleges AO Not Done`, accessor: "total_not_ao_app_24",
        //             Cell: ({ row }) => (
        //                 <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
        //                     onClick={() => {
        //                         if (row?.original?.total_not_ao_app_24 === 0) {
        //                             InfoAlert("No Data Found")

        //                         }
        //                         else {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 21);
        //                             setShowName("Total Colleges AO Not Done")
        //                         }

        //                     }}
        //                     onKeyDown={(e) => {
        //                         if (e.key === 'Enter' || e.key === ' ') {
        //                             GettUniversityWiseCourseDetails(row?.original?.ub_code, 21);
        //                             setShowName("Total Colleges AO Not Dones")
        //                         }
        //                     }}  >{row?.values?.total_not_ao_app_24}</div>
        //             ),
        //             Footer: "total_not_ao_app_24"
        //         },


        //     ]
        // },




    ]
    const Level2Columns = [

        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "University Name", accessor: "ub_name", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },

        {
            Header: "College Code", accessor: "coll_code", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_code}</div>
            ),
        },
        {
            Header: "College Name", accessor: "inst_name", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },

        ...(showName === "Total Colleges AO Done" || showName === `Private Aided Colleges AO Done ${AC_YEAR} ` || showName === `Govt Colleges AO Done ${AC_YEAR}`
            ? [
                {
                    Header: "Affiliation Order", accessor: "final_pdf_path", Footer: "",
                    Cell: ({ row }) => (
                        <button
                            type="button"
                            onClick={() => viewImage(row?.values?.final_pdf_path)}
                            style={{ color: "red" }}
                        >
                            <FaFilePdf size={23} />
                        </button>
                    ),
                },

            ]
            : []),


    ]
    const [overallOamdcStatus, setOverallOamdcStatus] = useState([]);
    function GetAfflCourseConversionOrderDetails() {
        let url = config.url.API_URL + `getaffloverallstatus`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setOverallOamdcStatus(res?.data?.data)
                setShowDrillCount(0)
            }
            else {
                setOverallOamdcStatus([])
            }
        })
    }


    useEffect(() => {
        GetAfflCourseConversionOrderDetails();


    }, [])
    function isBackFunction() {
        setShowDrillCount(showDrillCount - 1)
    }
    return (
        <div>
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                    {showDrillCount === 0 && (
                        <>
                            <div className="inner-herbpage-service-title-sub pt-0"  >
                                <h1>Govt./Private Aided Colleges Affiliation Overall Status Report</h1>
                            </div>
                            <bie.Row className="my-3 px-3">
                                <div className="table-responsive">
                                    <CommonReactTable data={overallOamdcStatus} columns={OverallOamdcStatusColumns} filename="Govt./Private Aided Colleges Affiliation Overall Status Report"
                                        headerName={`Govt./ Private Aided Colleges Affiliation Overall Status Report`} showFooter={"true"} />
                                </div>
                            </bie.Row>
                        </>
                    )}
                    {(showDrillCount === 1) && (
                        <bie.Row className="my-3 px-3">
                            <div className="inner-herbpage-service-title-sub pt-0"  > <h1>{showName}</h1> </div>
                            {universityWiseCourseData && universityWiseCourseData?.length > 0 ? (

                                <div className="table-responsive">
                                    <CommonReactTable data={universityWiseCourseData} columns={Level2Columns} filename={showName}
                                        headerName={showName} isBack={true} isBackFunction={isBackFunction} />
                                </div>
                            ) : (
                                <b className='text-error text-center'> ***No data Found***</b>
                            )}
                        </bie.Row>
                    )}
                </bie.Container>
            </bie.Container>
        </div>
    )
}
